export default __webpack_public_path__ + "static/media/fejleszd.2dead8a2.png";